import { render, staticRenderFns } from "./ClipboardInput.vue?vue&type=template&id=fabf9bec&scoped=true"
import script from "./ClipboardInput.vue?vue&type=script&lang=js"
export * from "./ClipboardInput.vue?vue&type=script&lang=js"
import style0 from "./ClipboardInput.vue?vue&type=style&index=0&id=fabf9bec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabf9bec",
  null
  
)

export default component.exports